<template>
  <v-card class="news-card" @click="open" elevation="4">
    <video
        v-if="item.video"
        class="news-video"
        :src="item.video"
        muted
        playsinline
        preload="metadata"
    ></video>
    <v-img v-else :src="item.image" height="200px" cover />

    <v-card-text>
      <div class="meta">
        <span class="mr-3">{{ item.category }}</span>
        <span>{{ item.date }}</span>
      </div>

      <h3>{{ item.title }}</h3>
      <p class="desc">{{ item.description }}</p>

      <v-btn variant="text" color="primary">Читать →</v-btn>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: ['item'],
  methods: {
    open() {
      // если задана кастомная ссылка — используем её
      if (this.item.link) {
        // внешняя ссылка
        if (this.item.link.startsWith('http')) {
          window.open(this.item.link, '_blank')
        } else {
          // внутренняя ссылка
          this.$router.push(this.item.link)
        }
        return
      }

      // иначе стандартный переход на страницу новости
      this.$router.push(`/news/${this.item.slug}`)
    }
  }
}
</script>

<style scoped lang="sass">
.news-card
  cursor: pointer
  transition: 0.3s

  &:hover
    transform: translateY(-6px)

.news-video
  width: 100%
  height: 200px
  display: block
  object-fit: cover

.v-card-title
  word-break: normal
  white-space: normal

.v-card-text
  word-break: normal
</style>
